/**
 * Episode Presentational Component
 * View: Displays an episode
 */

require('../styles/episode.scss');
require('../../node_modules/react-image-gallery/styles/scss/image-gallery.scss');

import React from 'react';

const EpisodeInfo = ({data}) => {

  function stripHtml(OriginalString){
    let StrippedString = OriginalString.replace(/(<(script.+\/script)>)/ig,''); // remove script
    StrippedString = StrippedString.replace(/(<([^ab][^>]+)>)/ig,'');
    return StrippedString;
  }

  return (
    <div className="episode-info">
      <h1 className="title">{data.title}</h1>
      <div className="guide">
        <div className="guide__column-left">
          {(()=>{
            if(data.title_img){
              return (<img className="guide__title-img" src={data.title_img} alt=""/>)
            }
          })()}
          <p className="guide__subtitle-comic">{data.subtitle_comic}</p>
          <a href="http://unis.ca/guides-daventures" target="unis.ca" className="video-button"><span className="play-icon"></span><div>Visionner la bande-annonce de l’émission SUR <span className="unis-logo">Unis.tv</span></div></a>
        </div>

        <div className="guide__column-right">
          <div className="guide__section">
            <h2 className="name">{data.name}</h2>
            <div className="profession"><span className="label">Profession&nbsp;: </span>{data.profession}</div>
            <div className="experience"><span className="label">Années d'expérience&nbsp;: </span>{data.experience}</div>
            <div className="location"><span className="label">Lieu d'aventure&nbsp;: </span>{data.location}</div>
            {/*<div className="subtitle_comic">{data.subtitle_comic}</div>*/}
          </div>

          <div className="guide__section--bio">
            <div className="guide__bio">
              <h2>Biographie</h2>
              <p dangerouslySetInnerHTML={{ __html: stripHtml(data.bio) }} />
            </div>
            <div className="guide__genese">
              <h2>Genèse</h2>
              <p>{data.genesis}</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

EpisodeInfo.propTypes = {
  data: React.PropTypes.object.isRequired
};

export default EpisodeInfo;



// WEBPACK FOOTER //
// ./src/components/EpisodeInfo.js